import { eRoutes } from "../routes"
import { icons } from "../utils/icons"

export const breadCrumbs = {
  dashboard: { name: "Dashboard", to: eRoutes["/"], icon: icons.dashboard },
  reports: { name: "Reports", to: eRoutes["/reports"], icon: icons.reports },

  actionTags: { name: "Alerts", to: "/action-tags", icon: icons.actionTags },
  newActionTags: { name: "Create new action tag", to: "/action-tags/new" },

  rotaShiftTypes: { name: "Rota Entry Type", to: "/rota-shift-types" },
  newRotaShiftTypes: { name: "Create new Rota Entry Type", to: "/rota-shift-types/new" },

  questions: { name: "Questions", to: eRoutes["/questions"] },
  newQuestions: { name: "Create new question", to: eRoutes["/questions/new"] },

  questionSets: { name: "Question Sets", to: eRoutes["/question-sets"] },
  newQuestionSets: { name: "Create new question set", to: eRoutes["/question-sets/new"] },

  sections: { name: "Sections", to: "/sections" },
  newSections: { name: "Create new section", to: "/sections/new" },

  flows: { name: "Flows", to: "/flows" },
  newFlows: { name: "Create new flow", to: "/flows/new" },

  risks: { name: "Risks", to: "/risks" },
  newRisks: { name: "Create new risk", to: "/risks/new" },

  resolutions: { name: "Help", to: "/help" },
  newResolutions: { name: "Create new help item", to: "/help/new" },

  companies: { name: "Companies", to: "/companies" },
  newCompanies: { name: "Create new company", to: "/companies/new" },

  outcomes: { name: "Outcomes", to: "/outcomes" },
  newOutcomes: { name: "Create new outcome", to: "/outcomes/new" },

  flowTags: { name: "Flow Tags", to: "/flow-tags" },
  newFlowTags: { name: "Create new flow tag", to: "/flow-tags/new" },

  progressTags: { name: "Progress Tags", to: eRoutes["/progress-tags"], icon: icons.label },
  newProgressTags: { name: "Create new progress tag", to: eRoutes["/progress-tags/new"] },

  adminEmails: { name: "Emails", to: eRoutes["/admin/emails"] },

  files: { name: "Files", to: "/files" },
  newFiles: { name: "Upload new file", to: "/files/new" },

  flowFiles: { name: "File Approver Requests", to: "/result-file-requests" },

  transcripts: { name: "Transcripts", to: "/transcripts" },
  newTranscripts: { name: "Upload", to: "/transcripts/new" },

  flowGroups: { name: "Flow Groups", to: "/flows" },
  newFlowGroups: { name: "Create new flow group", to: "/flow-groups/new" },

  results: { name: "Results", to: "/results", icon: icons.results },
  adminResults: { name: "Results", to: "/admin/results" },

  feedback: { name: "Feedback", to: "/feedback" },

  helpRequests: { name: "Help Requests", to: "/help-requests" },

  editTeamHrProfiles: { name: "Company settings", to: "/manage-team?pageTab=hrProfiles" },

  manageEmployees: { name: "Employees", to: eRoutes["/manager/employees"], icon: icons.employees },
  manageUsers: { name: "Users", to: eRoutes["/manager/users"], icon: icons.users },
  appraisals: { name: "Appraisals", to: "/appraisals" },
  adminUsers: { name: "Admin Users", to: "/admin-users" },
  newAdminUsers: {
    name: "Create new Admin",
    to: "/admin-users/new",
  },

  informationItems: { name: "Information items", to: "/information-items" },
  newInformationItems: { name: "Create new information item", to: "/information-items/new" },

  featureHighlights: { name: "Updates", to: "/updates" },
  newFeatureHighlights: { name: "Create new highlight", to: "/updates/new" },

  billing: { name: "Billing", to: "/billing" },
  plans: { name: "Plans", to: "/billing/plans" },
  newPlans: { name: "Create new plan", to: "/billing/plans/new" },
  perUserPlans: { name: "Per User Plans", to: "/billing/per-user-plans" },
  newPerUserPlans: { name: "Create new plan", to: "/billing/per-user-plans/new" },
  paymentHistory: { name: "Payment History", to: "/billing/payment-history" },
  subscriptions: { name: "Subscriptions", to: "/billing/subscriptions" },

  emails: { name: "Email Templates", to: "/emails" },

  adminHrProfileIndex: { name: "HR Profiles", to: eRoutes["/hr-profiles"] },
  hrManageTeamProfile: { name: "Your HR Profile", to: "/hr-profile" },
  hrReviewsIndex: { name: "Reviews", to: "/reviews" },
  hrWorkHistoryIndex: { name: "Work History", to: "/work-history" },
  hrWorkHistoryCompletedIndex: { name: "Completed Work", to: "/completed-work-history" },
  userRecruitmentDashboard: { name: "Recruit", to: "/recruitment" },
  userHrProfilesIndex: { name: "Profiles", to: eRoutes["/hr-profiles"] },
  userHrTeamProfilesIndex: { name: "Team", to: eRoutes["/hr-team"] },
  userJobRequestsIndex: { name: "Job Requests", to: "/reminders?pageTab=requests" },

  website: { name: "Website", to: "/admin/web" },
  websiteEnquiries: { name: "Enquiries", to: "/admin/web/enquiries" },
  websiteFaqs: { name: "FAQs", to: "/admin/web/faqs" },
  websiteNewFaqs: { name: "Create new FAQ", to: "/admin/web/faqs/new" },
  websiteReviews: { name: "Reviews", to: "/admin/web/reviews" },
  websiteNewReviews: { name: "Create new review", to: "/admin/web/reviews/new" },
  websiteCaseStudies: { name: "Case Studies", to: "/admin/web/case-studies" },
  websiteNewCaseStudies: { name: "Create new case study", to: "/admin/web/case-studies/new" },
  websiteBlogs: { name: "Blogs", to: "/admin/web/blogs" },
  websiteNewBlogs: { name: "Create new blog", to: "/admin/web/blogs/new" },

  userCompanySettings: { name: "Company Settings", to: "/manage-team", icon: icons.settings },
} as const
